import { getShopSimpleList } from '@/api/merchant/shop-manager'

const shopMap = ref<Record<number, string>>({})
let loaded = false

/**
 * 店铺名称查找 hook（全局缓存，只加载一次）
 */
export function useShopName() {
  if (!loaded) {
    loaded = true
    getShopSimpleList().then((list: any[]) => {
      const map: Record<number, string> = {}
      list?.forEach((s: any) => { map[s.id] = s.name || `店铺${s.id}` })
      shopMap.value = map
    })
  }

  const shopName = (shopId: number) => {
    if (!shopId) return '-'
    return shopMap.value[shopId] || `店铺${shopId}`
  }

  return { shopName }
}
